import { pick } from 'lodash'
import { browserHistory } from 'react-router'
import typewriter from 'analytics/typewriter'

function pageTrackingWarning(route) {
  if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
    console.warn(
      `Warning: Possible duplicate 'page' call detected on route: "${route}".\nManual 'analytics.page' calls should not be used. Page tracking happens automatically on route change (see routes.js).`
    )
  } else {
    typewriter.pageCallDuplicated({ route })
  }
}

let lastPageCallProps: {
  autotracked?: boolean
  route?: string
  url?: string
} = {}

// Note this seemingly fires before `<Router onUpdate={() => {}} />`
browserHistory.listen(() => {
  // Whenever the route changes, we need to wipe the slate clean so we aren't tracking false positives
  // for routes that are missing page calls entirely.
  lastPageCallProps = {}
})

window.analytics.on('page', (...args) => {
  // Gotta check if the args are using a different method signature
  // page(properties, options, callback)
  // page(name, properties, options, callback)
  // page(category, name, properties, options, callback)
  const props: any = Array.from(args).find(arg => typeof arg !== 'string' && arg !== null) || {}

  // Save a copy of the last page call to warn on duplicates
  if ((props.autotracked || lastPageCallProps.autotracked) && lastPageCallProps.url === props.url) {
    pageTrackingWarning(props.route || lastPageCallProps.route)
  }

  lastPageCallProps = pick(props, ['autotracked', 'route', 'url'])
})

/**
 * We have instrumented auto-page tracking at the react-router level on every route change.
 * You should not be reaching for this unless you've got some really important business.
 * You'll see this used in a few places today due to legacy reasons where we do not want to break
 * existing reporting that relies on custom properties in ad-hoc page calls.
 *
 * In general you shouldn't need to add page tracking as long as you are using the Router
 * and isolating each "page" that should be tracked as a unique route.
 */
export function UNSAFE_PAGE_CALL(...args) {
  window.analytics.page(...args)
}
